import { createContext } from "react";

export const authContext = createContext();

const AuthProvider = ({ authData, children }) => (
  <authContext.Provider value={authData}>{children}</authContext.Provider>
);

export default AuthProvider;
